import { getOr } from 'lodash/fp'

import { LoggedInUser } from 'common/user-context'

import { LawyerRequest, LocalAdviceRequest } from '../interfaces'
import { ChancelleryLocationsQuery, Filter, FilterOperator, SaveAdviceRequestInput } from '../interfaces/schemaDefinition'

export const hasEConsult: (
  chancelleryId: string,
  chancelleries: ChancelleryLocationsQuery['chancelleryLocations']['list']
) => boolean = (chancelleryId, chancelleries) =>
  getOr(
    false,
    'eConsult.active',
    chancelleries.find(c => c.id === chancelleryId)
  )

export const didSendToEConsult: (adviceRequest: LawyerRequest) => boolean = adviceRequest =>
  !!adviceRequest.history && !!adviceRequest.history.find(h => h.event === 'sentToEConsult')

const NEVER_FILTER = {
  name: 'chancelleryId',
  operator: FilterOperator.Equals,
  value: 'never',
}

export const getChancelleryFilter: (user: LoggedInUser | undefined, chancelleries: Array<{ id: string }>) => Filter = (
  user,
  chancelleries
) => {
  if (!user) {
    return NEVER_FILTER
  }

  if (user.organisationType === 'chancelleryGroup') {
    return {
      name: '',
      operator: FilterOperator.Or,
      value: chancelleries.map(c => ({
        name: 'chancelleryId',
        operator: FilterOperator.Equals,
        value: c.id,
      })),
    }
  }

  const chancellery = chancelleries.find(c => c.id === user.organisation)
  return {
    name: 'chancelleryId',
    operator: FilterOperator.Equals,
    value: chancellery ? chancellery.id : '',
  }
}

type AssignedRequest = {
  assignedTo?: LawyerRequest['assignedTo']
}

export const wasRedirected = (adviceRequest: LawyerRequest): boolean =>
  !!adviceRequest.history.find(history => history.event === 'redirectedAdviceRequest')

export const isAssignable: (adviceRequest: AssignedRequest, user: LoggedInUser) => boolean = (adviceRequest, user) =>
  !adviceRequest.assignedTo?.id || adviceRequest.assignedTo?.id === user.id

export const isAssignableToMe: (adviceRequest: AssignedRequest) => boolean = adviceRequest => !adviceRequest.assignedTo?.id

export const convertToSaveAdviceRequestInput = (adviceRequest: LocalAdviceRequest): SaveAdviceRequestInput => {
  const fieldOfLawId = adviceRequest.fieldOfLaw ? adviceRequest.fieldOfLaw.id : ''
  const language = adviceRequest.language ? adviceRequest.language.code : 'de'
  const person = {
    foa: adviceRequest.foa,
    firstname: adviceRequest.firstname,
    lastname: adviceRequest.lastname,
    email: adviceRequest.email,
    phone: adviceRequest.phone,
    address: {
      street: adviceRequest.street,
      streetNr: adviceRequest.streetNr,
      city: adviceRequest.city,
      zip: adviceRequest.zip,
    },
  }

  return { ...adviceRequest, fieldOfLawId, language, person }
}
